import { usePropsResolution } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';
import { Box } from '../box';
import { Icon } from '../icon';

import type { RewardsBadgeProps } from './types';

export const RewardsBadge = ({
  accessibilityLabel,
  children,
  isLocked,
  ...props
}: RewardsBadgeProps) => {
  const resolvedProps = usePropsResolution('RewardsBadge', { isLocked, ...props });

  const iconColor = resolvedProps.color;
  const iconVariant = isLocked ? 'locked' : 'rewards';

  return (
    // eslint-disable-next-line react-native-a11y/has-accessibility-hint
    <Box {...resolvedProps} accessibilityLabel={accessibilityLabel}>
      <Icon variant={iconVariant} size="xs" mr="$1" color={iconColor} />
      {children}
    </Box>
  );
};

export default addWithConfig(RewardsBadge);
